/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserInfo } from './userInfo';


export interface NotifyOptions { 
    userInfo: Array<UserInfo>;
    callFromContext: string;
    contextPath?: string;
    contextId?: string;
    contextName?: string;
    contextProjectName?: string;
    contextProjectNumber?: string;
    editorDescription?: string;
}

